module.exports = __webpack_public_path__ + "static/media/loading-ico.96a5f168.svg";